import cx from 'classnames';
import { KeystoneGroupMember } from './KeystoneGroupMember';

export function KeystoneGroupMembers(props: any) {
  const { run, role, eventNamespace } = props;
  const membersForRole = run.roster.filter((m: any) => m.role === role);

  if (membersForRole.length === 0) {
    return <div className={cx('text-muted', props.className)}>&mdash;</div>;
  }

  return (
    <div className={cx(props.className, props.allowWrap && 'slds-grid slds-wrap')}>
      {membersForRole.map((m: any) => (
        <KeystoneGroupMember
          key={m.character.id}
          season={run.season}
          team={eventNamespace ? run.platoon?.slug : run.keystone_team_id}
          eventNamespace={eventNamespace}
          teamDetailsRoute={props.teamDetailsRoute}
          {...m}
        />
      ))}
    </div>
  );
}
